import { getRequest, postRequest } from 'utils/http'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'

const REPORT_QUERY_KEY = 'reports_analytics'

export const getReportsAnalytics = async (params = {}) => {
  return getRequest('reports/analytics', { params })
}

export const useGetReportsAnalytics = (params = {}) => {
  return useQuery({
    queryKey: [REPORT_QUERY_KEY, params],
    queryFn: () => getReportsAnalytics(params),
    refetchInterval: 30000,
  })
}

export const getEventReport = async (eventId, params = {}) => {
  return getRequest(`reports/events/${eventId}`, { params })
}

export const useGetEventReport = (eventId, params = {}, options = {}) => {
  return useQuery({
    queryKey: ['event_report', eventId, params],
    queryFn: () => getEventReport(eventId, params),
    enabled: !!eventId && eventId !== 'all',
    ...options,
  })
}

export const refundOrder = async ({ orderId, reason }) => {
  return postRequest(`orders/${orderId}/refund`, { reason })
}

export const useRefundOrder = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: refundOrder,
    onSuccess: () => {
      queryClient.invalidateQueries([REPORT_QUERY_KEY])
      queryClient.invalidateQueries(['event_report'])
      queryClient.invalidateQueries(['tickets'])
    },
  })
}

